import {Typography} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

import Button from '@cdo/apps/legacySharedComponents/Button';
import i18n from '@cdo/locale';

import LibraryIdCopier from './LibraryIdCopier';

export default class PublishSuccessDisplay extends React.Component {
  static propTypes = {
    libraryName: PropTypes.string.isRequired,
    channelId: PropTypes.string.isRequired,
    onShareTeacherLibrary: PropTypes.func,
  };

  render = () => {
    const {libraryName, channelId, onShareTeacherLibrary} = this.props;
    return (
      <div>
        <Typography variant="h2" gutterBottom>
          <b>{i18n.libraryPublishTitle()}</b>
          {libraryName}
        </Typography>
        <div>
          <p>{i18n.libraryPublishExplanation()}</p>
          <div style={styles.centerContent}>
            <LibraryIdCopier channelId={channelId} />
            {onShareTeacherLibrary && (
              <Button
                color={Button.ButtonColor.gray}
                onClick={onShareTeacherLibrary}
                text={i18n.manageLibraries()}
              />
            )}
          </div>
        </div>
      </div>
    );
  };
}

const styles = {
  centerContent: {
    display: 'flex',
    justifyContent: 'center',
  },
};
